// RG-572 — Tipo Gestión en Carga Masiva.
// Espeja reccol-fnc-carga-masiva/tipoGestion.js: si cambia el mapa rol → grupo, actualizar ambos.

// Concepto IND 207 (tipos de gestión); su `agrupacion` apunta al grupo IND 314.
export const CONCEPTO_TIPO_GESTION = 207;

const GRUPO_RECUPERO = '314001';
const GRUPO_DEFENSA = '314002';

// Roles de análisis que habilitan el combo y el grupo de tipos de gestión que ven.
export const GRUPO_POR_ROL = {
    '0070ANREC0': GRUPO_RECUPERO,
    '0070ANDEF0': GRUPO_DEFENSA,
    '0070ANDEFPE': GRUPO_DEFENSA
};

// Tipos que acepta el servidor (recupero-fnc-carga-archivo): Recupero, Defensa Civil y Defensa Penal.
const TIPOS_SOPORTADOS = ['207001', '207002', '207006'];

export const gruposDeRoles = (roles) => {
    const grupos = (roles || []).map(r => GRUPO_POR_ROL[r && r.rol]).filter(Boolean);
    // Sin spread sobre Set: microbundle (modo loose) lo transpila a [].concat(Set) y rompe el resultado.
    return grupos.filter((g, i) => grupos.indexOf(g) === i);
};

// El combo solo aplica si el rol del usuario mapea a algún grupo.
export const aplicaTipoGestion = (roles) => gruposDeRoles(roles).length > 0;

// Opciones de IND 207 (`{ id, nombre, agrupacion }`) permitidas para los roles del usuario.
export const opcionesTipoGestion = (tipos, roles) => {
    const grupos = gruposDeRoles(roles);
    return (tipos || []).filter(t =>
        TIPOS_SOPORTADOS.includes(String(t.id)) && grupos.includes(String(t.agrupacion))
    );
};
